import { render, staticRenderFns } from "./tagFacesModal.vue?vue&type=template&id=6b8a75c0&scoped=true"
import script from "./tagFacesModal.vue?vue&type=script&lang=js"
export * from "./tagFacesModal.vue?vue&type=script&lang=js"
import style0 from "./tagFacesModal.vue?vue&type=style&index=0&id=6b8a75c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a75c0",
  null
  
)

export default component.exports